module.exports = __webpack_public_path__ + "static/img/title-banner1-type4.bc40861.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/8/title-banner1-type4.png
// module id = ppOs
// module chunks = 1